"use client";

import { Box, styled } from "@mui/material";

const Ghost = styled(Box)({
  position: "absolute",
  inset: 0,
  backgroundImage: "url('/img/floats/floats-logo-blue.svg')",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "70%",
  opacity: 1,
});

export default function FallbackLogo() {
  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
      <Ghost />
    </Box>
  );
}
